export default "__VITE_ASSET__IRhiIgS6__"